<div class="d-flex flex-column align-items-center">
  <div class="card mt-5 col-md-6 p-4 mr-0 p-gutter flex-auto max-w-[900px] overflow-auto max-h-[80vh]">
    <div class="d-flex flex-column align-items-end" (click)="close()"> <span style="cursor: pointer;">&times;</span>
    </div>
    <h5>Import Candidates Data</h5>
    <div class="mr-0 d-flex flex-column align-items-center">

      <div class="mb-3 mr-0 col-md-10">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" [(ngModel)]="reImport"
            [ngModelOptions]="{ standalone: true }">
          <label class="form-label">Re-Import</label>
        </div>
      </div>

      <button class="btn btn-primary btn-lg col-md-10" rel="noopener noreferrer" (click)="importData()">Import Data
      </button>
    </div>
  </div>
</div>